namespace Nobox
{
    @Serenity.Decorators.registerFormatter()
    export class UsersNmFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            let idList = ctx.value;
            if (!idList)
                return "";

            idList = idList.split(",") as string[]
            var elList = "";
            var idLast = "";
            idList.forEach(function (x) {
                idLast = Q.getLookup("Nobox.UsersLookup").itemById[x]["DisplayName"];
                elList += `<span id="${x.toString()}" class="users-link">${Q.getLookup("Nobox.UsersLookup").itemById[x]["DisplayName"]}, </span>`;
            });
            return `<a href="javascript:;">${elList.replace(idLast.toString() + ", ", idLast.toString())} </a>`;
        }
    }
}
